
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/[slug]",
      function () {
        return require("private-next-pages/case-study/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/[slug]"])
      });
    }
  